export default {
	API_BASE: "https://dh90q9pb01dyh.cloudfront.net/api/"
};
